import { DocPrintTemplatesStore } from '../../../../doc-templates/doc-print-templates/state/doc-print-template.store';
import { Component, computed, effect, inject, OnInit, signal, WritableSignal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { SharedModule } from '@digiwall/goliath-core';
import { DocRole } from '@digiwall/goliath-core/proxy';
import { CustomerSalesPurchaseService } from '@digiwall/goliath-documents/proxy';
import { DialogBoxComponent } from '@digiwall/ui-kit';
import { NgbActiveOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectComponent } from '@ng-select/ng-select';
import { TextTemplateDto } from '@digiwall/core/proxy';
import { ToasterService } from '@abp/ng.theme.shared';
import { LoadingService } from '@digiwall/core';

@Component({
  selector: 'document-proforma',
  templateUrl: './generate-proforma-dialog.component.html',
  imports: [DialogBoxComponent, SharedModule, ReactiveFormsModule, NgSelectComponent],
})
export class ProformaComponent implements OnInit {
  public customerSalesPurchaseReference: WritableSignal<string> = signal('');
  public customerSalesPurchaseId: WritableSignal<string> = signal('');
  public customerSalesPurchaseLanguageId: WritableSignal<string> = signal('');
  public textTemplates: WritableSignal<TextTemplateDto[]> = signal([]);
  public currentPrintTemplateId: WritableSignal<string> = signal('');

  protected docPrintTemplatesTypeStore = inject(DocPrintTemplatesStore);
  protected form: FormGroup;

  constructor(
    private salesPurchaseService: CustomerSalesPurchaseService,
    protected modal: NgbActiveOffcanvas,
    private toastService: ToasterService,
    private loadingService: LoadingService,
    private formBuilder: FormBuilder,
  ) {
    effect(() => {
      this.form.get('printTemplateId')?.setValue(this.currentPrintTemplateId());
    });
  }

  ngOnInit(): void {
    this.initForm();
  }

  private initForm() {
    this.form = this.formBuilder.group({
      reference: [this.customerSalesPurchaseReference()],
      sendProforma: [false, Validators.required],
      printTemplateId: [null, Validators.required],
      textTemplateId: [null],
    });
  }

  docPrintTemplatesEntities = computed(() => {
    const docRole = DocRole.CustomerSalesPurchase;
    return this.docPrintTemplatesTypeStore.entities().filter(x => x.roles.includes(docRole));
  });

  generateProforma() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.loadingService.interceptNextRequest();
    this.salesPurchaseService
      .generateProforma(
        this.form.get('reference').value,
        this.customerSalesPurchaseId(),
        this.form.get('printTemplateId').value,
      )
      .subscribeOnce(result => {
        this.modal.close({
          sendEmail: this.form.get('sendProforma').value,
          proforma: result,
          textTemplateId: this.form.get('textTemplateId').value,
        });
      });
  }
}
